import * as accessibility from "./accessibility.css";
import * as contentCard from "./content-card.css";
import * as form from "./form.css";
import * as layout from "./layout.css";
import * as lede from "./lede.css";
import * as login from "./login.css";
import * as membership from "./membership.css";
import * as text from "./text.css";
import * as userProfiles from "./user-profiles.css";
import * as utils from "./utils.css";

export const sharedStyles = {
  accessibility,
  contentCard,
  form,
  layout,
  lede,
  login,
  membership,
  text,
  userProfiles,
  utils,
};
